import * as GroupToggle from "../../client/js/components/GroupToggle.ts";

export function initMenuToggle() {
  GroupToggle.init();
}
